import { render, staticRenderFns } from "./EnrollRecord.vue?vue&type=template&id=b788b68a&scoped=true&"
import script from "./EnrollRecord.vue?vue&type=script&lang=js&"
export * from "./EnrollRecord.vue?vue&type=script&lang=js&"
import style0 from "./EnrollRecord.vue?vue&type=style&index=0&id=b788b68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b788b68a",
  null
  
)

export default component.exports